module.exports = __webpack_public_path__ + "static/media/Novideo1.e1508635.png";